module.exports = __webpack_public_path__ + "static/media/title-topp-butikker.44bd018d.png";